import axios from 'axios'

const request = axios.create({
  baseURL: '/api',
  timeout: 15000,
  withCredentials: true
})

export const listNotes = (params = {}) => {
  return request.get('/note/list', { params })
}

export const createNote = (data) => {
  return request.post('/note/add', data)
}

export const updateNote = (id, data) => {
  return request.put(`/note/update/${id}`, data)
}

export const deleteNote = (id) => {
  return request.delete(`/note/delete/${id}`)
}

export const pinNote = (id, value = 1) => {
  return request.put(`/note/pin/${id}`, null, { params: { value } })
}

